export const NotificationCategory = {
  Undefined: 0,
  Email: 1,
  Push: 2,
} as const;

export type NotificationCategory =
  (typeof NotificationCategory)[keyof typeof NotificationCategory];

export const NotificationType = {
  Undefined: 0,
  Marketing: 1,
  Transactional: 2,
  Newsletter: 3,
  Surveys: 4,
  Global: 5,
} as const;

export type NotificationType =
  (typeof NotificationType)[keyof typeof NotificationType];

export interface UserNotificationSettings {
  id: string;
  category: NotificationCategory;
  type: NotificationType;
  isEnabled: boolean;
  title: string;
  description: string;
  index: number;
}

export interface UserNotificationUpdate {
  category: NotificationCategory;
  type: NotificationType;
  isEnabled: boolean;
}
